import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue'
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router'
import { eventCenter, event } from '@evideo/frontend-utils'
import { getTeacherCourseware } from '../service'
import config from '@/config'
import PptEditor from '@/components/ppt-editor/PptEditor.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()

const pptId = route.params.id
const recordId = route.params.recordId

const fileInfo = ref<any>({})

const pptEditor = ref()

const fileName = ref<string>('')

const url = ref(null)

const handleGoBack = () => {
  router.push('/resource/mine-coursewares/share-list')
}

onBeforeRouteLeave((to, from, next) => {
  eventCenter.send(event.COMMON_UNLOAD_MICRO_APP, {
    app: config.pptist.name
  })
  setTimeout(() => {
    next()
  }, 0)
})

onMounted(async () => {
  const data = await getTeacherCourseware((pptId as string))
  url.value = data.url || ''
  fileName.value = data.name
  fileInfo.value = data
})


return (_ctx: any,_cache: any) => {
  const _component_a_page_header = _resolveComponent("a-page-header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_page_header, {
      title: "预览课件",
      subTitle: fileName.value,
      style: {"background-color":"white"}
    }, {
      extra: _withCtx(() => [
        _createElementVNode("a", { onClick: handleGoBack }, "返回")
      ]),
      _: 1
    }, 8, ["subTitle"]),
    _createVNode(PptEditor, {
      resource: url.value,
      ref: (_value, _refs) => {
        _refs['pptEditor'] = _value
        pptEditor.value = _value
      },
      type: "preview",
      resourceType: "share",
      width: "100%",
      height: "90vh",
      autoHideMenu: true,
      "is-teacher-mine": "true",
      ids: _unref(recordId)
    }, null, 8, ["resource", "ids"])
  ], 64))
}
}

})